/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Delete Icon.
 */
export const DeleteIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M17.806 6.94434V20.2499C17.806 20.526 17.5821 20.7499 17.306 20.7499H6.47266C6.19651 20.7499 5.97266 20.526 5.97266 20.2499V6.94434' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M4 4.26807H19.7777' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M8.93066 3L14.8473 3' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
    </svg>
  );
};
